module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel extras"
  }, [_c('h4', {
    staticClass: "mb-3 pb-3 border-bottom-light"
  }, [_vm._v("Extras")]), _vm._v(" "), (_vm.extras.length > 0) ? _c('ul', {
    staticClass: "table fs-normal bare"
  }, _vm._l((_vm.extras), function(extra, index) {
    return _c('li', {
      staticClass: "d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom-light"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(extra.item.name) + "\n\n                "), (extra.isMandatory) ? _c('span', [_vm._v("(mandatory)")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "price fs-small ml-auto mr-5 dark"
    }, [(extra.priceIncluded) ? _c('div', [_vm._v("\n                    (event price includes this extra)\n                ")]) : _c('div', [_vm._v("\n                    " + _vm._s(extra.item.priceTotal) + " €\n                ")])]), _vm._v(" "), _c('calculator', {
      attrs: {
        "object": extra.item,
        "field": "quantity",
        "editable": _vm.editable
      },
      on: {
        "mathDone": _vm.mathDone
      }
    })], 1)
  }), 0) : _c('div', [_vm._v("This product has no extras available.")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4be58976", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be58976"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Extras.vue
// module id = 2193
// module chunks = 0